// DISP-6 — entry points for the BL print. Called by DISP-5a/5b ("Print BL") and the order page ("Delivery note" for a
// direct/cash order). Imperative on purpose: no host state needed. Printing is stateless: nothing is written, no number is minted.
import React from 'react';
import { createRoot } from 'react-dom/client';
import DispatchSlipPrintHost from './DispatchSlipPrintHost';

function open(props) {
  const el = document.createElement('div');
  document.body.appendChild(el);
  const root = createRoot(el);
  const done = () => { root.unmount(); el.remove(); };
  root.render(React.createElement(DispatchSlipPrintHost, { ...props, onDone: done }));
  return done;
}

// Persisted slip (draft/open/delivered/cancelled). showPrices: omit to ask in the dialog (default quantity-only);
// pass true/false to skip the dialog. Returns a function that closes it.
export const openDispatchSlipPrint = (slipId, { showPrices } = {}) => open({ slipId, showPrices });

// D10: a delivered BL on demand for a direct/cash order WITHOUT a persisted slip: no number, labelled "Delivery note
// (no BL number)", built from what the order says was delivered. deliveryEventId is accepted for the wiring but no
// read API exposes per-event rows yet, so the note lists the order's delivered quantities.
export const openDeliveredBlPrint = (operationId, deliveryEventId = null, { showPrices } = {}) => open({ operationId, deliveryEventId, showPrices });
